import React, { useContext, useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import useFormValidator from 'useFormValidator';
import * as actions from '../../../action';

function CreateLandSubItemModal({
  createLandSubItem,
  getLandClassificationsList,
  getSubClassificationsItemsList,
  history,
  classificationId,
  getSingleLandClass,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
  });

  const validateForm = useFormValidator(formData, {
    name: 'required',
    description: 'required',
  });

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const payload  = {
      ...formData,
      id: classificationId
    }
    createLandSubItem(payload, ({ data }) => {
      setModal({ isOpen: false });
      getLandClassificationsList();
      history.push(`/rpt/land/land-settings/land-classification/${data.attributes.rptax_land_classification_id}`);
      getSingleLandClass(data.attributes.rptax_land_classification_id);
      getSubClassificationsItemsList(data.attributes.rptax_land_classification_id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Name {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Description {validateForm.renderMessage('description')}
            </label>
            <input
              className="form-control"
              type="text"
              name="description"
              onChange={onChange}
              value={_.get(formData, 'description')}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button 
            type="submit" 
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
            disabled={!validateForm.response.is_passed}
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateLandSubItemModal.propTypes = {
  getLandClassificationsList: PropTypes.instanceOf(Function).isRequired,
  getSubClassificationsItemsList: PropTypes.instanceOf(Function).isRequired,
  createLandSubItem: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  classificationId: PropTypes.string.isRequired,
  getSingleLandClass: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateLandSubItemModal);
